import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

export default function ContactForm() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [values, setValues] = useState({ name: "", email: "", message: "" });
  const [errors, setErrors] = useState({});
  const [submitting, setSubmitting] = useState(false);

  const validate = () => {
    const e = {};
    if (!values.name.trim()) e.name = t("form.validation_required");
    if (!values.email.trim()) e.email = t("form.validation_required");
    else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(values.email)) e.email = t("form.validation_email");
    if (!values.message.trim()) e.message = t("form.validation_required");
    return e;
  };

  const onSubmit = (ev) => {
    ev.preventDefault();
    const e = validate();
    setErrors(e);
    if (Object.keys(e).length) return;
    setSubmitting(true);
    // frontend-only: push to dataLayer + redirect
    try {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ event: "contact_form_submitted", name: values.name });
    } catch (_) {}
    const nameParam = encodeURIComponent(values.name.trim().split(" ")[0] || "");
    setTimeout(() => {
      navigate(`/thank_you${nameParam ? `?name=${nameParam}` : ""}`);
    }, 250);
  };

  const set = (k) => (ev) => setValues((v) => ({ ...v, [k]: ev.target.value }));

  return (
    <form className="fp-form" onSubmit={onSubmit} noValidate>
      <div className="fp-field">
        <label htmlFor="fp-name">{t("form.name_label")}</label>
        <input
          id="fp-name"
          type="text"
          value={values.name}
          onChange={set("name")}
          placeholder={t("form.name_placeholder")}
          aria-invalid={!!errors.name}
          autoComplete="name"
        />
        {errors.name && <small className="fp-field__err">{errors.name}</small>}
      </div>

      <div className="fp-field">
        <label htmlFor="fp-email">{t("form.email_label")}</label>
        <input
          id="fp-email"
          type="email"
          value={values.email}
          onChange={set("email")}
          placeholder={t("form.email_placeholder")}
          aria-invalid={!!errors.email}
          autoComplete="email"
        />
        {errors.email && <small className="fp-field__err">{errors.email}</small>}
      </div>

      <div className="fp-field">
        <label htmlFor="fp-message">{t("form.message_label")}</label>
        <textarea
          id="fp-message"
          rows={4}
          value={values.message}
          onChange={set("message")}
          placeholder={t("form.message_placeholder")}
          aria-invalid={!!errors.message}
        />
        {errors.message && <small className="fp-field__err">{errors.message}</small>}
      </div>

      <button type="submit" className="fp-btn fp-btn--primary fp-btn--block" disabled={submitting}>
        {t("form.submit")} <span aria-hidden="true">→</span>
      </button>

      <p className="fp-form__note">{t("form.privacy_note")}</p>
    </form>
  );
}
